import React, { useEffect, useState } from "react";
import { convertTime, get } from "../functions";
import { DataTable, Loader, UnAuth } from "../components";

const VoterCount = () => {
  const [voterCount, setVoterCount] = useState([]);
  const [loading, setLoading] = useState(true);
  const [unauth, setUnAuth] = useState(false);
  const headCells = ["S.NO", "Station", "Count"];
  let total = 0;

  const getVoterCount = async () => {
    const response = await get("/public/voter-count");
    if (response?.status === "Success") {
      setVoterCount(response.data);
    } else if (
      response?.status === "Error" &&
      response?.message === "Unauthorized access."
    ) {
      setUnAuth(true);
    }
    setLoading(false);
  };

  useEffect(() => {
    getVoterCount();
  }, []);

  if (unauth) {
    return <UnAuth />;
  }

  if (loading) {
    return <Loader />;
  }

  return (
    <main className="main">
      <section>
        <h1 className="heading">Voter Count</h1>
        <DataTable headCells={headCells}>
          {voterCount.map(({ polling_station_name, voter_count }, ind) => {
            total += voter_count;
            return (
              <tr key={ind}>
                <td className="text-center">{ind + 1}</td>
                <td>{polling_station_name}</td>
                <td className="text-center">{voter_count}</td>
              </tr>
            );
          })}
          <tr className="bg-brown text-white *:font-medium">
            <td colSpan={2}>Total</td>
            <td className="text-center">{total}</td>
          </tr>
        </DataTable>
      </section>
    </main>
  );
};

export default VoterCount;
